import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import testScore from '../test-templates/test-score';
import './QuizQuestionsList.scss'
import Question from "../test-templates/Question";
import classNames from 'classnames'
import notificationsActionCreators from "../../store/notifications/action-creators";
import testsActionCreators from "../../store/tests/action-creators";
import LoadingButton from '../../../shared/ui/LoadingButton';

function mapStateToProps(state) {
  return {
    userContext: state.common.userContext,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    sendNotification(notification) {
      return dispatch(notificationsActionCreators.addNotification(notification));
    },
    retryTest(form) {
      return dispatch(testsActionCreators.retryTest(form));
    },
    finishTest(form) {
      return dispatch(testsActionCreators.finishTest(form));
    }
  };
}

class QuizQuestionsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      answers: this.props.answers || {},
      score: 0,
      counter: 0,
      currentQuestion: this.props.questions[0],
      isLoading: false,
      startTime: (new Date).toISOString(),
      minutes: this.props.testTemplate.duration,
      seconds: 0,
      questionMinutes: null,
      questionSeconds: null,
      spentSeconds: 0,
      subjectiveQuestionsScore: {}
    }
  }

  get overAllScore() {
    if (this.props.score != null) {
      return this.props.score
    }

    if (!this.props.questions) {
      return 0
    }
    return testScore(this.props.questions, this.state.answers);

  }

  get isPassed() {
    return (this.props.passingScore <= this.overAllScore || this.props.passed)
  }

  get retryTest() {
    return this.props.testObj.finished_at;
  }

  get minutes() {
    return this.state.minutes > 9 ? this.state.minutes : '0' + this.state.minutes;
  }

  get seconds() {
    return this.state.seconds > 9 ? this.state.seconds : '0' + this.state.seconds;
  }

  get questionMinutes() {
    if (this.state.questionMinutes == null) {
      return null;
    }

    return this.state.questionMinutes > 9 ? this.state.questionMinutes : '0' + this.state.questionMinutes;
  }

  get questionSeconds() {
    if (this.state.questionSeconds == null) {
      return null;
    }

    return this.state.questionSeconds > 9 ? this.state.questionSeconds : '0' + this.state.questionSeconds;
  }

  get hasSubjectiveQuestion() {
    const subjectiveQuestions = this.props.questions.filter(question => {
      return question.isSubjective
    }, 0);

    return subjectiveQuestions.length > 0;
  }

  componentDidMount() {
    this.startTestTimer();
    this.questionTimer(this.props.questions[this.state.counter], this.state.answers[this.props.questions[this.state.counter].id]);
    this.startTimeSpentCounter();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.questions) {
      this.setState({
        currentQuestion: this.props.questions[this.state.counter],
        startTime: (new Date).toISOString(),
      })
    }
  }

  componentWillUnmount() {
    this.clearAllTimers();
  }

  clearAllTimers() {
    clearInterval(this.finishTestInterval);
    clearInterval(this.remainingTime);
    clearInterval(this.finishQuestionInterval);
    clearInterval(this.remainingQuestionTime);
    clearInterval(this.timeSpentCounter);
  }

  startTestTimer() {
    const testEndTimestamp = moment(this.props.testObj.started_at).add(this.state.minutes, 'minutes');
    const milisecondsDuration = moment.duration(testEndTimestamp.diff(moment())).asMilliseconds();

    const secondsDuration = milisecondsDuration  / 1000;
    const remainingMinutes = secondsDuration / 60;
    const remainingSeconds = secondsDuration % 60;

    this.setState({
      minutes: Math.floor(remainingMinutes),
      seconds: Math.floor(remainingSeconds)
    });

    if (milisecondsDuration > 0) {
      this.finishTestInterval = setInterval(() => {
        clearInterval(this.finishTestInterval);
        this.submitTest(this.state.currentQuestion, this.state.answers[this.state.currentQuestion.id], true, true);
      }, milisecondsDuration);

      this.remainingTime = setInterval(() => {
        const { seconds, minutes } = this.state
        if (seconds > 0) {
          this.setState(({ seconds }) => ({
            seconds: seconds - 1
          }))
        }
        if (seconds === 0) {
          if (minutes === 0) {
            clearInterval(this.remainingTime)
          } else {
            this.setState(({ minutes }) => ({
              minutes: minutes - 1,
              seconds: 59
            }))
          }
        }
      }, 1000);
    }
  }

  startTimeSpentCounter() {
    clearInterval(this.timeSpentCounter);

    this.setState({
      spentSeconds: 0
    });

    this.timeSpentCounter = setInterval(() => {
      this.setState(({spentSeconds}) => ({
        spentSeconds: spentSeconds + 1
      }));
    }, 1000);
  }

  questionTimer(question, answers) {
    clearInterval(this.finishQuestionInterval);
    clearInterval(this.remainingQuestionTime);

    if (question.questionDuration) {
      let milisecondsDuration = null;
      if (answers == undefined) {   // when we first open the question
        const currentTime = moment();
        const questionEndTimestamp = currentTime.add(question.questionDuration, 'minutes');
        milisecondsDuration = moment.duration(questionEndTimestamp.diff(moment())).asMilliseconds();
      } else {    // when we go back to the question
        const startedAtMoment = moment(answers.started_at);
        const answeredAtMoment = moment(answers.answered_at);
        const alreadySpentMiliSeconds = moment.duration(answeredAtMoment.diff(startedAtMoment)).asMilliseconds();

        milisecondsDuration = question.questionDuration * 60000 - alreadySpentMiliSeconds;
      }

      const secondsDuration = milisecondsDuration / 1000;
      const remainingMinutes = Math.floor(secondsDuration / 60);
      const remainingSeconds = Math.floor(secondsDuration % 60);

      this.setState({
        questionMinutes: remainingMinutes,
        questionSeconds: remainingSeconds
      });

      if (milisecondsDuration > 0) {
        this.finishQuestionInterval = setInterval(() => {
          clearInterval(this.finishQuestionInterval);

          this.setState({
            answers: {
              ...this.state.answers,
              [question.id]: {
                ...this.state.answers[question.id],
                isDurationLimitExceeded: true
              }
            }
          });

          this.saveAnswers(this.state.currentQuestion, this.state.answers[this.state.currentQuestion.id], false);
          this.nextQuestion(this.state.currentQuestion, this.state.answers[this.state.currentQuestion.id], true);
        }, milisecondsDuration);

        this.remainingQuestionTime = setInterval(() => {
          const {questionSeconds, questionMinutes} = this.state;
          if (questionSeconds > 0) {
            this.setState(({questionSeconds}) => ({
              questionSeconds: questionSeconds - 1
            }))
          }
          if (questionSeconds === 0) {
            if (questionMinutes === 0) {
              clearInterval(this.remainingQuestionTime)
            } else {
              this.setState(({questionMinutes}) => ({
                questionMinutes: questionMinutes - 1,
                questionSeconds: 59
              }))
            }
          }
        }, 1000);
      }
    } else {
      this.setState({
        questionMinutes: null,
        questionSeconds: null
      });
    }
  }

  updateAnswer(question, answers) {
    this.setState({
      answers: {
        ...this.state.answers,
        [question.id]: {
          ...this.state.answers[question.id],
          answers: answers.answers,
          correct: answers.correct
        }
      }
    })
  }

  isQuestionAnswered(question, answer) {
    if (question.isSubjective) {
      return true;
    }

    return answer && answer.answers && answer.answers.length > 0;
  }

  submitTest(question, answers, enablePartiaAnswers, updateAnsweredAt) {
    answers = answers || {answers: []};
    if (!this.props.questions.every(question => this.isQuestionAnswered(question, this.state.answers[question.id])) && !enablePartiaAnswers) {
      this.props.sendNotification({
        id: Date.now(),
        type: 'error',
        content: 'You have to fill all of the questions'
      })
    } else {
      this.clearAllTimers();

      if (!answers.started_at) {
        answers.started_at = this.state.startTime;
        answers.answered_at = (new Date).toISOString();
      } else if (answers.started_at && updateAnsweredAt) {
        const newAnsweredAtTime = moment(answers.answered_at).add(this.state.spentSeconds, 'seconds');
        answers.answered_at = newAnsweredAtTime.toISOString();
      }

      if (answers) {
        this.setState({
          answers: {
              ...this.state.answers,
              [question.id]: answers
          }
        })
      }

      this.props.onSubmit({
        answers: this.state.answers
      }).then((data) => {
        this.props.sendNotification({
          id: Date.now(),
          type: 'success',
          content: 'You have successfully submitted the test'
        })


        const form = {
          id: this.props.testObj.id,
          finished_at: (new Date).toISOString()
        };

        this.props.finishTest(form);
      })
    }
  }

  saveAnswers(question, answers, showNotification) {
    if (answers && !answers.answers) {
      answers.answers = [];
    }

    this.setState({
      answers: {
        ...this.state.answers,
        [question.id]: answers
      }
    })

    this.props.onSubmit({
      answers: this.state.answers
    }).then(() => {
      if (showNotification) {
        this.props.sendNotification({
          id: Date.now(),
          type: 'success',
          content: 'You have successfully saved the answers'
        })
      }
    })
  }

  nextQuestion(question, answers, enablePartiaAnswers) {
    this.setState({isLoading: true});
    answers = answers || {answers: []};

    let counter = this.state.counter + 1;
    if (!enablePartiaAnswers && !this.isQuestionAnswered(question, answers)) {
        setTimeout(() => {
            this.setState({
              isLoading: false,
            })
        }, 700);

        this.props.sendNotification({
          id: Date.now(),
          type: 'error',
          content: 'You have to answer the question'
        })
    }
    else if (counter < this.props.questions.length) {
      this.updateAnsweredAtTimestamp(answers);
      this.saveAnswers(question, this.state.answers[question.id], false);

      while (true) {
        if (this.props.questions[counter] &&
          this.state.answers[this.props.questions[counter].id] &&
          this.state.answers[this.props.questions[counter].id].isDurationLimitExceeded) {

          counter++;
        } else if (!this.props.questions[counter]) {
          break;
        }

        if (this.props.questions[counter] &&
          (!this.state.answers[this.props.questions[counter].id] ||
            !this.state.answers[this.props.questions[counter].id].isDurationLimitExceeded)) {

          break;
        } else if (!this.props.questions[counter]) {
          break;
        }
      }

      if (!this.props.questions[counter]) {
        this.setState({
          isLoading: false,
          startTime: (new Date).toISOString()
        });

        this.submitTest(question, this.state.answers[question.id], true, false);
        return;
      }

        setTimeout(() => {
          this.questionTimer(this.props.questions[counter], this.state.answers[this.props.questions[counter].id]);
          this.startTimeSpentCounter();

          this.setState({
            counter: counter,
            currentQuestion: this.props.questions[counter],
            isLoading: false,
            startTime: (new Date).toISOString()
          });
        }, 700);
    } else {
      this.updateAnsweredAtTimestamp(answers);
      this.setState({
        isLoading: false,
        startTime: (new Date).toISOString()
      });

      this.submitTest(question, this.state.answers[question.id], true, false);
    }
  }

  updateAnsweredAtTimestamp(answers) {
    if (answers) {
      if (answers.answered_at == undefined) {
        answers.answered_at = (new Date).toISOString();
      } else {
        const newAnsweredAtTime = moment(answers.answered_at).add(this.state.spentSeconds, 'seconds');
        answers.answered_at = newAnsweredAtTime.toISOString();
      }

      if (answers.started_at == undefined) {
        answers.started_at = this.state.startTime;
      }
    }

    this.setState({
      answers: {
        ...this.state.answers,
        [this.state.currentQuestion.id]: answers
      }
    });
  }

  onRetryTest(questionId) {
    const form = {
      id: questionId,
      started_at: (new Date).toISOString() 
    };
    this.props.retryTest(form).then((newTest) =>  {
      this.props.onTestRetried(newTest);
    });
  }

  onUpdateScore(score, question) {
    let subjectiveQuestionsScore = this.state.subjectiveQuestionsScore;
    subjectiveQuestionsScore[question.id] = score;

    this.setState({
      subjectiveQuestionsScore
    });
  }

  saveScore() {
    console.log('this.state.subjectiveQuestionsScore', this.state.subjectiveQuestionsScore)
  }

  render() {
    return (
      <div className={classNames('question-list', {'fading': this.state.isLoading})}>
        <div className={classNames("question-status", {
          passed: this.isPassed,
          failed: !this.isPassed,
        })}>
          {this.props.status === 'started' ? (
            <span>You have {this.minutes}:{this.seconds} minutes to finish the test</span>
          ) : null}

          {this.props.status === 'started' ? (
            <Fragment>
              {/* <button className="button small primary" onClick={() => this.saveAnswers(this.state.currentQuestion, this.state.answers[this.state.currentQuestion.id], true)}>
                <i className="fa fa-save"/>
                Save
              </button> */}

              <button className="button small primary"
                      onClick={() => this.submitTest(this.state.currentQuestion, this.state.answers[this.state.currentQuestion.id], false, true)}>
                SUBMIT TEST
              </button>
            </Fragment>
          ) : null}


          {this.props.testObj.finished_at &&
            <div className="results-container">
              <div className="score-container">
                {this.overAllScore}% {(this.props.passingScore <= this.overAllScore || this.props.passed) ?
                <span className="correct">PASSED</span> : <span className="incorrect">FAILED</span>}
              </div>

              <div>
                {this.props.questions.map(question => (
                  <Question
                    key={question.id}
                    question={question}
                    answers={this.state.answers[question.id]}
                    canEdit={false}
                    canAnswer={false}
                    testEnded={true}
                    showAnswer={this.props.userContext.hasScope(['fto', 'ftoc']) ? true : this.props.testTemplate.allowTakerViewResults}
                    updateScore={this.onUpdateScore.bind(this)}
                  />
                ))}
              </div>
            </div>
          }
        </div>
        {this.state.currentQuestion && !this.retryTest &&
            <Fragment>
                <div className="question-number">
                  <p>{this.state.counter + 1}/{this.props.questions.length}</p>
                  {this.questionMinutes && this.questionSeconds && !this.state.isLoading &&
                  <p className="question-timer">{this.questionMinutes}:{this.questionSeconds}</p>
                  }
                </div>

                <Question
                    key={this.state.currentQuestion.id}
                    question={this.state.currentQuestion}
                    answers={this.state.answers[this.state.currentQuestion.id]}
                    canEdit={this.props.canEdit}
                    canAnswer={this.props.status !== 'completed'}
                    showAnswer={this.props.showAnswer}
                    allowTakerChangeAnswerIfCorrectDisplayed={this.props.testTemplate.allowTakerChangeAnswerIfCorrectDisplayed}
                    allowTakerViewCorrectAnswer={this.props.testTemplate.allowTakerViewCorrectAnswer}
                    onAnswer={(answers) => this.updateAnswer(this.state.currentQuestion, answers)}
                    onEdit={() => this.props.onEdit(this.state.currentQuestion)}
                />

                {(this.state.counter + 1 < this.props.questions.length) &&
                    <div className="next-question-container">
                      <LoadingButton
                        primary
                        isLoading={this.state.isLoading}
                        text="Next Question"
                        onClick={() => this.nextQuestion(this.state.currentQuestion, this.state.answers[this.state.currentQuestion.id], false)}
                      />
                    </div>
                }
            </Fragment>
        }
        {this.props.testTemplate.attempts > 1 && !this.props.passed && this.retryTest &&
          <div className="retry-btn">
            <LoadingButton
              primary
              isLoading={this.state.isLoading}
              text="Retry Test"
              onClick={() => this.onRetryTest(this.props.testObj.id)}
            />
          </div>
        }

        {this.hasSubjectiveQuestion && this.props.testObj && this.props.testObj.finished_at && this.props.userContext.hasScope(['fto']) && (
          <div className="save-score-container">
            <button className="button small secondary" onClick={() => this.saveScore()}>
              Save Score
            </button>  
          </div>
        )}
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuizQuestionsList);
